import { cva } from "class-variance-authority";

const avatar = cva(
  "object-cover rounded-full flex items-center justify-center bg-brand font-semibold text-white",
  {
    variants: {
      size: {
        sm: "w-8 h-8 text-xs",
        md: "w-9 h-9 text-sm",
        lg: "w-12 h-12 text-lg",
        xl: "w-[60px] h-[60px] text-xl",
      },
    },
  },
);

interface AvatarProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  size?: "sm" | "md" | "lg" | "xl";
  src?: string;
  alt?: string;
  isLoading?: boolean;
}

export function Avatar({
  size = "md",
  src,
  alt,
  className,
  isLoading,
  ...props
}: AvatarProps) {
  if (isLoading) {
    return (
      <div className={avatar({ size, className })}>
        <div className="bg-gray-300 w-full h-full rounded-full" />
      </div>
    );
  }

  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        className={avatar({ size, className })}
        {...props}
      />
    );
  }

  const splitText = alt?.split(" ") ?? [];
  const avatarText =
    splitText.length > 1
      ? splitText[0]?.charAt(0) + splitText[1]?.charAt(0)
      : splitText[0]?.slice(0, 2);

  return (
    <div className={avatar({ size, className })} {...props}>
      {avatarText}
    </div>
  );
}
